import { useTranslation } from "react-i18next";

import { IconButton } from "../iconButton";

import classes from "./styles.module.scss";
import AvailableDoctorTimeGrid from "./availableDoctorTimeGrid";

import type { IAvailableDoctorCardProps } from ".";

import { Avatar } from "@/components/atoms/avatar";
import { Box } from "@/components/atoms/box";
import { Icon } from "@/components/atoms/icons";
import { Typography } from "@/components/atoms/typography";

export function AvailableDoctorGridCard(props: IAvailableDoctorCardProps) {
  const {
    score,
    scoreCount,
    address,
    firstName,
    hf,
    lastName,
    specialty,
    subSpecialty,
    avatar,
    onView,
    ...rest
  } = props;

  const { t } = useTranslation("form");
  const { t: tc } = useTranslation("common");

  return (
    <Box px={"0"} py={"0"} radius={"md"} className={"position-relative h-100 "}>
      {onView && (
        <div className={classes["operation-button"]}>
          <IconButton
            icon={<Icon name={"Eye"} />}
            label={tc("view")}
            transparent
            onClick={onView}
          />
        </div>
      )}
      <div className={"d-flex-column align-items-center gap-xs p-l1"}>
        <Avatar
          size={"small"}
          userInfo={{
            firstName,
            lastName,
            imageUrl: avatar || "",
          }}
        />
        <div className={"flex-item-center mt-m1 gap-xs"}>
          <Icon name={"Rate"} color={"warning-main"} type={"bold"} />
          <Typography
            fontSize={"xs"}
            color={"primary-main"}
            fontWeight={"semi-bold"}
          >{`${score} ${t("score")}`}</Typography>
          <Typography
            variant={"caption2"}
            fontWeight={"regular"}
            color={"secondary-text-light"}
          >{`(${scoreCount} ${t("user")})`}</Typography>
        </div>
        <Typography fontSize={"xl"} fontWeight={"bold"}>{`${t(
          "doctor",
        )} ${firstName} ${lastName}`}</Typography>
        <Typography variant={"regularCaption"}>{specialty.value}</Typography>
        <div className={"d-flex gap-xs mt-m3"}>
          <Icon name={"Hospital"} color={"primary-main"} />
          <Typography variant={"subtitle2"}>{hf.value}</Typography>
        </div>
      </div>
      <div className={"p-m4 border-top"}>
        <AvailableDoctorTimeGrid {...rest} />
      </div>
    </Box>
  );
}
